import styled from 'styled-components'

export const PinBlock = styled.div(({ theme }) => ({
  borderTop: `${theme.border.size['1']} solid ${theme.colors.gray400}`,
  display: 'flex',
  flexDirection: 'column',
  gap: theme.space['12'],
  // Note: horizontal/bottom padding match FieldRow's inline padding (EL-12782) —
  // this block previously had paddingTop only, leaving its content flush against
  // the card's left/right/bottom edges instead of aligned with the rows above it.
  padding: `${theme.space['12']} ${theme.space['16']}`,
}))

export const IssueRow = styled.div(({ theme }) => ({
  alignItems: 'center',
  display: 'flex',
  gap: theme.space['12'],
}))

export const IssuedInfo = styled.div(({ theme }) => ({
  alignItems: 'center',
  display: 'flex',
  flexWrap: 'wrap',
  gap: theme.space['8'],
}))

export const PinWarning = styled.div(({ theme }) => ({
  alignItems: 'center',
  backgroundColor: theme.colors.red100,
  border: `${theme.border.size['1']} solid ${theme.colors.red200}`,
  borderRadius: theme.border.radius['8'],
  display: 'flex',
  gap: theme.space['8'],
  padding: `${theme.space['8']} ${theme.space['12']}`,
}))
